import React, { useEffect } from 'react';
import './FeedFilterDrawer.css';

const FILTERS = ['All', 'P2P', 'Following', 'Merchants'];

export default function FeedFilterDrawer({
  open,
  onClose,
  activeFilter = 'All',
  onSelect,
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="popup-backdrop bf-feedfilter-backdrop" onClick={onClose}>
      <div
        className="bf-feedfilter-sheet"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Feed filters"
      >
        <div className="bf-feedfilter-handle" />

        <div className="bf-feedfilter-header">
          <div className="bf-feedfilter-title">Feed</div>
          <button className="bf-feedfilter-close" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        <div className="bf-feedfilter-list">
          {FILTERS.map((label) => {
            const isActive = activeFilter === label;
            return (
              <button
                key={label}
                className={`bf-feedfilter-item ${isActive ? 'active' : ''}`}
                onClick={() => onSelect?.(label)}
                type="button"
              >
                <span className="bf-feedfilter-radio" aria-hidden="true" />
                <span className="bf-feedfilter-label">{label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
